module.exports = {
	MULTIPLE_CHOICE: 0,
	TEXT: 1,
	// CLICK_OR_TOUCH: 2,
	// TEXT_SUBQUESTIONS: 3,
	EXTERNAL_ACTIVITY: 4,
	IMAGE_MULTIPLE_CHOICE: 5,
	VOCAB_MULTIPLE_CHOICE: 6,
	QUESTION_TYPE_SPOKEN: 7
};
